import { render, staticRenderFns } from "./drilldown-b.vue?vue&type=template&id=1f72b9f5"
import script from "./drilldown-b.vue?vue&type=script&lang=js"
export * from "./drilldown-b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports